export { default } from './Carousel';
export type { Slide } from './Carousel';
export type { Props, Props as CarouselProps } from './Carousel';
